var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header'),_c('div',{staticClass:"content-div"},[_c('router-view')],1),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_vm._v("Copyright © 2022 J&F Mobility Pte.Ltd. - All Rights Reserved. "),_c('a',{staticStyle:{"color":"#fff"},attrs:{"href":" ","target":"_blank"}},[_vm._v("蜀ICP备2023010898号-2")])])
}]

export { render, staticRenderFns }